module.exports = __webpack_public_path__ + "static/media/pause~DGJtxxjE.fc20d564.png";